// extracted by mini-css-extract-plugin
module.exports = {"content":"SimpleChannel_content__3cKKg","accessDenied":"SimpleChannel_accessDenied__2XM6n"};